// Libraries
import create from 'zustand';
import { persist } from 'zustand/middleware';

// Types
import {
  LengthType,
  MeasurementType,
  PressureType,
  TemperatureType,
} from '../types/global';

export interface MeasurementStore {
  [MeasurementType.length]: LengthType;
  [MeasurementType.pressure]: PressureType;
  [MeasurementType.temperature]: TemperatureType;
}

export const useMeasurementStore = create(
  persist<MeasurementStore>(
    () => ({
      length: LengthType.mm,
      pressure: PressureType.MPa,
      temperature: TemperatureType.c,
    }),
    {
      name: 'measurement-store',
      getStorage: () => localStorage,
    },
  ),
);

export const getMeasurementUnit = <T extends keyof MeasurementStore>(
  measurementType: T,
): MeasurementStore[T] => useMeasurementStore.getState()[measurementType];

export const setMeasurementUnit = (
  value: LengthType | PressureType | TemperatureType,
  measurementType: MeasurementType,
): void => {
  useMeasurementStore.setState((state: MeasurementStore) => ({
    ...state,
    [measurementType]: value,
  }));
};
